import { createFileRoute } from '@tanstack/react-router';
import { LeadWizard } from '../features/leads/wizard/LeadWizard';

export const Route = createFileRoute('/leads/new')({
  component: LeadWizard,
});
